export default [
  {
    icon: 'mdi-sync',
    title: 'Reschedule Jadwal',
    event: 'onReschedule',
    akses: 'psp-peserta-simulasi-ajar.jadwal-ulang',
  },
  {
    icon: 'mdi-close',
    title: 'Batal Reschedule',
    event: 'onBatalReschedule',
    akses: false,
  },
];
